var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFaq = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "21fecab42e"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("mask", {
    id: "a342dbcc6c"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#21fecab42e)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#000000",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 0.84
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "8774a44858"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.035156 1.035156 L 355.964844 1.035156 L 355.964844 355.964844 L 1.035156 355.964844 Z M 1.035156 1.035156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "79de52015a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.5 1.035156 C 80.488281 1.035156 1.035156 80.488281 1.035156 178.5 C 1.035156 276.511719 80.488281 355.964844 178.5 355.964844 C 276.511719 355.964844 355.964844 276.511719 355.964844 178.5 C 355.964844 80.488281 276.511719 1.035156 178.5 1.035156 Z M 178.5 1.035156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "112f92b457"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 357,
    y: 0,
    height: 357
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0dd30fe123"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62.292969 84.796875 L 312.792969 84.796875 L 312.792969 327 L 62.292969 327 Z M 62.292969 84.796875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a928c8b2d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 306.699219 84.796875 L 68.292969 84.796875 C 66.703125 84.796875 65.175781 85.429688 64.050781 86.554688 C 62.925781 87.679688 62.292969 89.207031 62.292969 90.796875 L 62.292969 266.484375 C 62.292969 268.078125 62.925781 269.601562 64.050781 270.730469 C 65.175781 271.855469 66.703125 272.484375 68.292969 272.484375 L 103.597656 272.484375 C 105.1875 272.484375 106.714844 273.117188 107.839844 274.242188 C 108.964844 275.367188 109.597656 276.894531 109.597656 278.484375 L 109.597656 322.945312 C 109.597656 324.160156 110.253906 325.28125 111.316406 325.875 C 112.375 326.46875 113.675781 326.441406 114.710938 325.804688 L 196.421875 275.625 C 199.765625 273.574219 203.609375 272.484375 207.535156 272.484375 L 306.699219 272.484375 C 308.289062 272.484375 309.816406 271.855469 310.941406 270.730469 C 312.066406 269.601562 312.699219 268.078125 312.699219 266.484375 L 312.699219 90.796875 C 312.699219 89.207031 312.066406 87.679688 310.941406 86.554688 C 309.816406 85.429688 308.289062 84.796875 306.699219 84.796875 Z M 306.699219 84.796875 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a342dbcc6c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 9, 9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#112f92b457)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8774a44858)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79de52015a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#750a0a",
    d: "M 1.035156 1.035156 L 355.964844 1.035156 L 355.964844 355.964844 L 1.035156 355.964844 Z M 1.035156 1.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0dd30fe123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a928c8b2d4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.75, 0, 0, 0.75, 62.293104, 84.796818)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 325.874841 0.0000754244 L 7.99982 0.0000754244 C 5.880028 0.0000754244 3.843569 0.843825 2.343569 2.343826 C 0.843569 3.843826 -0.000180879 5.880284 -0.000180879 8.000076 L -0.000180879 242.250091 C -0.000180879 244.375091 0.843569 246.406342 2.343569 247.91155 C 3.843569 249.41155 5.880028 250.250092 7.99982 250.250092 L 55.072739 250.250092 C 57.192531 250.250092 59.22899 251.093842 60.72899 252.593842 C 62.22899 254.093842 63.07274 256.130301 63.07274 258.250092 L 63.07274 317.531346 C 63.07274 319.151138 63.94774 320.64593 65.364407 321.437597 C 66.775865 322.229263 68.51024 322.192805 69.890449 321.343847 L 178.838373 254.437592 C 183.296706 251.703217 188.421706 250.250092 193.656082 250.250092 L 325.874841 250.250092 C 327.994632 250.250092 330.031091 249.41155 331.531091 247.91155 C 333.031091 246.406342 333.874841 244.375091 333.874841 242.250091 L 333.874841 8.000076 C 333.874841 5.880284 333.031091 3.843826 331.531091 2.343826 C 330.031091 0.843825 327.994632 0.0000754244 325.874841 0.0000754244 Z M 325.874841 0.0000754244 ",
    stroke: "#ffffff",
    strokeWidth: 22,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.623447, 204.302412)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.4375 -52.203125 L 15.4375 -29.625 L 45.140625 -29.625 L 45.140625 -24.375 L 15.4375 -24.375 L 15.4375 0 L 9.359375 0 L 9.359375 -57.453125 L 48.75 -57.453125 L 48.75 -52.203125 Z M 15.4375 -52.203125 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.58143, 204.302412)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 45.390625 -15.34375 L 13.375 -15.34375 L 6.484375 0 L 0.171875 0 L 26.421875 -57.453125 L 32.421875 -57.453125 L 58.6875 0 L 52.28125 0 Z M 43.171875 -20.265625 L 29.390625 -51.140625 L 15.59375 -20.265625 Z M 43.171875 -20.265625 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.434303, 204.302412)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 67.21875 4.84375 C 65.46875 6.976562 63.398438 8.601562 61.015625 9.71875 C 58.640625 10.84375 56.054688 11.40625 53.265625 11.40625 C 49.878906 11.40625 46.664062 10.570312 43.625 8.90625 C 40.582031 7.238281 37.175781 4.4375 33.40625 0.5 C 27.875 0.332031 22.890625 -1.035156 18.453125 -3.609375 C 14.023438 -6.179688 10.550781 -9.65625 8.03125 -14.03125 C 5.519531 -18.414062 4.265625 -23.316406 4.265625 -28.734375 C 4.265625 -34.253906 5.5625 -39.226562 8.15625 -43.65625 C 10.757812 -48.09375 14.375 -51.582031 19 -54.125 C 23.625 -56.675781 28.78125 -57.953125 34.46875 -57.953125 C 40.164062 -57.953125 45.296875 -56.691406 49.859375 -54.171875 C 54.429688 -51.648438 58.03125 -48.160156 60.65625 -43.703125 C 63.28125 -39.242188 64.59375 -34.253906 64.59375 -28.734375 C 64.59375 -23.910156 63.59375 -19.488281 61.59375 -15.46875 C 59.601562 -11.445312 56.816406 -8.09375 53.234375 -5.40625 C 49.648438 -2.726562 45.53125 -0.953125 40.875 -0.078125 C 45.082031 4.347656 49.238281 6.5625 53.34375 6.5625 C 57.613281 6.5625 61.253906 4.8125 64.265625 1.3125 Z M 10.265625 -28.734375 C 10.265625 -24.242188 11.316406 -20.191406 13.421875 -16.578125 C 15.523438 -12.960938 18.421875 -10.113281 22.109375 -8.03125 C 25.804688 -5.957031 29.925781 -4.921875 34.46875 -4.921875 C 39.007812 -4.921875 43.113281 -5.957031 46.78125 -8.03125 C 50.445312 -10.113281 53.316406 -12.960938 55.390625 -16.578125 C 57.472656 -20.191406 58.515625 -24.242188 58.515625 -28.734375 C 58.515625 -33.210938 57.472656 -37.257812 55.390625 -40.875 C 53.316406 -44.488281 50.445312 -47.332031 46.78125 -49.40625 C 43.113281 -51.488281 39.007812 -52.53125 34.46875 -52.53125 C 29.925781 -52.53125 25.804688 -51.488281 22.109375 -49.40625 C 18.421875 -47.332031 15.523438 -44.488281 13.421875 -40.875 C 11.316406 -37.257812 10.265625 -33.210938 10.265625 -28.734375 Z M 10.265625 -28.734375 "
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFaq, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FAQ.22d68e78.svg";
export { ForwardRef as ReactComponent };